import React, { useEffect, useState } from "react";
import { apiClient } from '../../helpers/api_helper';


import {
  CardBody,
  Card,
  Col,
  Container,
  Row,
  DropdownToggle,
  DropdownMenu,
  UncontrolledDropdown,
} from "reactstrap";
import DatePicker from  'react-datepicker';
import Widget from "../Analytics/Widget";
import Basic from "../AllCharts/line/Basic";
import Donut from "../AllCharts/pie/Donut";
import Markers from "../AllCharts/bar/markers";
import Markers2 from "../AllCharts/bar/markers2";
import Filter from "./filter";
import Channels from "../Analytics";
import { API_URL } from "src/utils/apiConfig";
import { formatNumber } from "src/helpers/format_helper";



const getDateMMyyyyFormatted = (date: Date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}${month}`;
};

interface DashboardAnalytics{
  valor_previsto: number;
  valor_contrato: number;
  saldo: number;
  nivel_execucao: string;
  atividades: number;
  dentro_do_prazo: number;
  fora_do_prazo: number;
  concluidas: number;
}

const Sales = () => {
  const [isLoading, setIsLoading] = useState(false);
  document.title = "Painel de Controlo - Khozi";
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [dashboardData, setDashboardData] = useState<DashboardAnalytics>();
  

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {        
        const response = await apiClient.get(`/analytics/dashboard/`);
        setDashboardData(response.data ? response.data : response);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };
    fetchDashboardData();
  }, []);

  useEffect(() => {
      if (isLoading) {
        document.body.style.cursor = 'wait';
      } else {
        document.body.style.cursor = 'default';
      }
  
      return () => {
        document.body.style.cursor = 'default';
      };
    }, [isLoading]); 
  

  function downloadOfficeFile(extension:string) {  
    const contentTypes = new Map<string, string>();
    contentTypes.set('xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    contentTypes.set('docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
    contentTypes.set('pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation');
  
    const url = `${API_URL}/excel/process-excel/?doc_type=${extension}&start_date=${getDateMMyyyyFormatted(startDate)}&finish_date=${getDateMMyyyyFormatted(endDate)}`;    
    
    setIsLoading(true);
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": `${contentTypes.get(extension)}`,
      },
    }).then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      setIsLoading(false);
      return response.blob();
    }).then(blob => {      
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `VCUI - Matriz de Monitoria_${getDateMMyyyyFormatted(startDate)}a${getDateMMyyyyFormatted(endDate)}.${extension}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      setIsLoading(false);
    }).catch(error => {
      console.error("There was a problem with the fetch operation:", error);
    });
  }


  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>          
          <UncontrolledDropdown>
            <DropdownToggle className="btn btn-dark" tag="a">
              <i className="uil uil-download-alt me-1"></i>{" "}
              Matriz de Monitoria
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <div className="p-3">
                <div className="row ">
                  <span className="mx-2">De</span>
                  <div className="col-sm">
                    <DatePicker                                
                      className="form-control"
                      selected={startDate}
                      onChange={(date: React.SetStateAction<Date>) => setStartDate(date)}
                      showMonthYearPicker
                      dateFormat="MM/yyyy"
                      showIcon
                    />
                  </div>
                  <span className="mx-2">até</span>
                  <div className="col-sm">
                    <DatePicker                                  
                      className="form-control"
                      selected={endDate}
                      onChange={(date: React.SetStateAction<Date>) => setEndDate(date)}
                      showMonthYearPicker
                      dateFormat="MM/yyyy"
                      showIcon
                    />
                  </div>
                </div>
                <div className="btn-group" role="group">
                  <button className="btn btn-success mt-3" onClick={() => downloadOfficeFile('xlsx')} disabled={isLoading}>
                    <i className="uil uil-table me-1"></i>Excel
                  </button>
                  <button className="btn btn-primary mt-3" onClick={() => downloadOfficeFile('docx')} disabled={isLoading}>
                    <i className="uil uil-file-alt me-1"></i>Word
                  </button>
                  <button className="btn btn-danger mt-3" onClick={() => downloadOfficeFile('pptx')} disabled={isLoading}>
                    <i className="uil uil-presentation me-1"></i>Powerpoint
                  </button>
                </div>
              </div>
            </DropdownMenu>
          </UncontrolledDropdown>    
          <button onClick={toggleDropdown} className="floating-filter-button">
            <i className="uil uil-filter"></i>
          </button>
          {dropdownOpen && <Filter />}
          <Row>
            <Col xl={3} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-18">
                          <i className="uil uil-list-ul"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1 text-truncate text-muted">Valor Previsto</p>
                      <h5 className="font-size-16 mb-0">
                        {formatNumber(dashboardData ? dashboardData.valor_previsto : 0)}
                      </h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-18">
                          <i className="uil uil-check-circle"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1 text-truncate text-muted">Valor de Contrato</p>
                      <h5 className="font-size-16 mb-0">
                        {formatNumber(dashboardData ? dashboardData.valor_contrato : 0)}
                      </h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-18">
                          <i className="uil uil-users-alt"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1 text-truncate text-muted">Saldo</p>
                      <h5 className="font-size-16 mb-0">
                        {formatNumber(dashboardData ? dashboardData.saldo : 0)}
                      </h5>  
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} sm={6}>
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-sm">
                        <div className="avatar-title bg-primary-subtle text-primary rounded-circle font-size-18">
                          <i className="uil uil-clock-eight"></i>
                        </div>
                      </div>
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="mb-1 text-truncate text-muted">Nível de Execução (%)</p>
                      <h5 className="font-size-16 mb-0">{dashboardData?.nivel_execucao}</h5>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>            
          </Row>
          <Row>
            <Col xl={8}>
            <Channels />
              {/*<Card>
                <CardBody>
                  <div className="d-flex align-items-start">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-4">Actividades por Mês</h5>
                    </div>
                  </div>
                  <div id="line_chart_basic" className="apex-charts" dir="ltr">
                    <Basic />
                    </div>
                </CardBody>
              </Card>*/}
            </Col>
            <Col xl={4} sm={6}>
              <Col>
              {dashboardData &&<Widget                 
                  atividades={dashboardData.atividades ? dashboardData.atividades: 0} 
                  dentro_do_prazo={dashboardData.dentro_do_prazo ? dashboardData.dentro_do_prazo: 0} 
                  fora_do_prazo={dashboardData.fora_do_prazo ? dashboardData.fora_do_prazo: 0} 
                  concluidas={dashboardData.concluidas ? dashboardData.concluidas: 0}
                />
              }
              </Col>
              <Col>
                <Card className="card-h-10">
                  <CardBody>
                    <div className="d-flex align-items-start">
                      <div className="flex-grow-1">
                        <h5 className="card-title">
                          Actividades por Financiador
                        </h5>
                      </div>
                    </div>
                    <Donut />
                  </CardBody>
                </Card>
              </Col>
            </Col>
          </Row>
          <Row>
            <Col xl={5}>
              <Card>
                <CardBody>
                  <div className="d-flex align-items-start">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-4">
                        Actividades por Responsável
                      </h5>
                    </div>
                  </div>
                  <div id="line_chart_basic" className="apex-charts" dir="ltr">
                    <Markers2 />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={7} sm={12}>
              <Card>
                <CardBody>
                  <div className="d-flex align-items-start">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-4">
                        Actividades por Departamento
                      </h5>
                    </div>
                  </div>
                  <div id="line_chart_basic" className="apex-charts" dir="ltr">
                    <Markers />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>          
        </Container>
      </div>
    </React.Fragment>
  );
};

const styles = `
  .floating-filter-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #038EDC;
    color: white;
    border: none;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    z-index: 1000;
  }

  .floating-filter-button:hover {
    background-color: #45a0d5;
  }
    
`;

// Inject styles into the document
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default Sales;
